export const messages = {
    error:{
        1: "Please enter your first name.",
        2: "Please enter a valid first name.",
        3: "Please enter your last name.",
        4: "Please enter a valid last name.",
        5: "Please enter your credentials.",
        6: "Please enter a valid credentials.",
        7: "Please enter your education details.",
        8: "Please select valid education details.",
        9: "Please enter your practice's state.",
        10: "Please enter a valid practice's state name.",
        11: "Please enter your license number.",
        12: "Please enter a valid license number.",
        13: "Please enter an email address.",
        14: "The email address seems to be incorrect.",
        15: "Seems like this email is already registered with us. Please login with this one or click on Forgot Password to reset your credentials.",
        16: "Entered password does not match.",
        17: "Please set a password for your account.",
        18: "Your password needs to include both lower and upper case characters, a number, a symbol, and at least 8 characters.",
        19: "Please enter your practice address.",
        20: "Please enter valid practice address.",
        21: "Seems like this email is already registered with us. Please enter another email address or sign in with this one.",
        22: "Seems like this license number is already in use. ",
        23: "Email Address not verified.",
        24: "Looks like your account does not exist. Sign up to create an account.",
        25: "Incorrect password. Please try again.",
        26: "Please enter a password.",
        27: "Please enter a new password.",
        28: "Please confirm your password.",
        29: "Please enter a valid password.",
        30: "Please enter a service name.",
        31: "Please enter a valid service name.",
        32: "Please enter a service description.",
        33: "Please enter a valid service description.",
        34: "Please enter your practice name.",
        35: "Please enter valid practice name.",
        36: "Please enter your contact number.",
        37: "Please enter valid contact number.",
        38: "Please enter your zip code.",
        39: "Please enter valid zip code.",
        40: "Please enter your license state/territory.",
        41: "Please enter valid license state/territory.",
        42: "Please enter your license authority.",
        43: "Please enter valid license authority.",
        44:"Please select a  license expiry date.",
        45: "Please select a liability insurance expiry date",
        46: "Zip code should be 10 digits in length.",
        47: "Please select a start time.",
        48: "Please select an end time.",
        49: "Please select a period.",
        50: "Please select a time interval.",
        51: "Please enter a valid facebook URL.",
        52: "Please enter a valid twitter URL.",
        53: "Please enter a valid linkedIn URL.",
        54: "Can't send invitation as the user is already registered with us.",
        55: "Please enter valid charges. ",
        56: "Entered email is not registered with a primary care veterinarian. ",
        57: "Entered email is not registered with a specialist. ",
        58: "Please enter your city.",
        59: "Please enter a valid city name.",
        60: "Please enter a valid social media URL.",
        61: "Invalid time.",
        62: "Please enter a valid license state/territory.",
        63: "Please enter your liability insurance provider.",
        64: "Please enter valid liability insurance provider.",
        65: "Please enter your credentials.",
        66: "Please enter valid credentials.",
        67: "Please enter your country.",
        68: "Please enter a valid country.",
        69: "Please enter your practice manager's name.",
        70: "Please enter a valid practice manager's name.",
        71: "Please enter your practice manager's email.",
        72: "Please enter a valid practice manager's email.",
        73: "Please select a time zone.",
        74: "Entered email is not registered with a admin. ",
        75: "Wrong current password.",
        76: "Current password and new password should not be same.",
        77: "Entered passwords are not matching.",
        78: "Seems like this email is already registered with us. Please enter another email address.",
        79: "Looks like your account does not exist.",
        80: "Please enter charges. charges range from 10-99999",
        81: "Please enter valid education details.",
        82: "Please enter your license state/territory.",
        83: "Please enter your full name.",
        84: "Please enter valid full name.",
        85: "Please enter your contact number.",
        86: "Please enter valid contact number.",
        87: "Please enter valid message.",
        88: "Please write a few words about you.",
        89: "Please enter valid instagram URL.",
        90: "Please select a service.",
        91: "Please enter your pet's name.",
        92: "Please enter valid pet's name.",
        93: "Please select pet's gender.",
        94: "Please enter owner's name.",
        95: "Please enter valid owner's name.",
        96: "Please specify if it’s a Cat, Dog or other.",
        97: "Please enter valid pet type",
        98: "Please enter pet's breed.",
        99: "Please enter valid pet's breed.",
        100: "Please enter pet's age in years.",
        101: "Year should be between 0-199.",
        102: "Please enter pet's age in months.",
        103: "Month should be between 0-12.",
        104: "Please enter pet's location.",
        105: "Please enter valid pet's location.",
        106: "Please enter issues.",
        107: "Please enter valid issues.",
        108: "Please enter valid madical history.",
        109: "Please enter valid question.",
        110: "Please enter pet's diet.",
        111: "Please enter valid pet's diet.",
        112: "Account is temporarily disabled, Please contact admin.",
        113: "Please enter subject.",
        114: "Please enter a valid subject.",
        115: "Please enter description.",
        116: "Please enter a valid description.",
        117: "Please enter a valid comment.",
        118: "Please enter pet's species.",
        119: "Please enter valid pet's species.",
        120: "Please enter pet's weight.",
        121: "Please select a unit.",
        122: "Please select DVM",
        123: "Please enter DVM name",
        124: "Please enter valid Clinic Contact Number"
    }
        
    
}